module.exports = "/images/Tunisia.png?1342ac8ead360cdda24eaad95d6fd0c5";